import React from 'react';
export function Footer() {
  return <footer className="bg-cream-100 py-10 px-5 sm:px-6 border-t border-cream-300" data-id="element-94" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto text-center" data-id="element-95" data-mp="3gg0yw2enzvx4">
        <div className="inline-flex items-center gap-2" data-id="element-96" data-mp="32o4bucrusc7l">
          <span className="text-xl" aria-hidden="true" data-id="element-97" data-mp="32pfci3q053uh">⭐</span>
          <span className="text-rose-600 font-bold tracking-widest uppercase" data-id="element-98" data-mp="36oo9dhgc9hu9">
            PUNTO DIGITAL™
          </span>
        </div>
        <p className="text-sm text-ink-muted leading-snug mt-2 max-w-xl mx-auto" data-id="element-99" data-mp="3uftn9r2py01x">
          Material visual y práctico para mujeres +40 que quieren conocer
          mejor su cuerpo y aprender a trabajar respiración, relajación,
          activación, coordinación y fuerza del suelo pélvico desde casa.
        </p>
        <p className="font-serif text-[15px] text-rose-700 leading-snug mt-3 max-w-xl mx-auto" data-id="element-100" data-mp="3qfjhofiu9bnl">
          “Porque trabajar tu suelo pélvico no debería significar hacer
          ejercicios al azar sin saber qué necesita tu cuerpo.”
        </p>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-sm text-ink-muted mt-4" data-id="element-101" data-mp="3l8qvi1vp0fqe">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-rose-600 transition-colors" data-id="element-102" data-mp="3gbimorwfpo1t">
            📧 supportpuntodigital@gmail.com
          </a>
          <span className="text-rose-300" aria-hidden="true" data-id="element-103" data-mp="3q8wp3nliwcb4">•</span>
          <a href="https://www.puntodigital.store" className="hover:text-rose-600 transition-colors" data-id="element-104" data-mp="3qaq1ljithqr1">
            🌐 www.puntodigital.store
          </a>
        </div>

        <hr className="w-[82%] mx-auto my-5 border-t border-rose-200" data-id="element-105" data-mp="335ujlmz7ril" />

        <p className="text-xs text-ink-soft" data-id="element-106" data-mp="htd4te2ty487">
          © Punto Digital™ 2026 — Todos los derechos reservados.
        </p>
        <p className="text-[11px] text-ink-soft mt-1" data-id="element-107" data-mp="cv1smwp2bhmt">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>

        <p className="text-[11px] text-ink-muted leading-relaxed mt-5 max-w-lg mx-auto" data-id="element-108" data-mp="mrwp7a1rz7yg">
          <span className="font-bold" data-id="element-109" data-mp="mq3g7o3owbna">AVISO:</span> Este material tiene fines
          educativos y de acompañamiento. No diagnostica, trata ni sustituye
          la evaluación o tratamiento de médicos, kinesiólogos especializados
          en suelo pélvico u otros profesionales de la salud cuando sean
          necesarios.
        </p>
      </div>
    </footer>;
}